import * as style from './Cat.css';
import { clsx } from 'clsx';
import { ArticleHeading4, LinkButton, ModalWindow, TDeviceType } from '@cian/ui-kit';
import { LINK_AN_AD } from 'shared/constants/links';

interface ICatProps {
  catVisible: boolean;
  modalVisible: boolean;
  device: TDeviceType;
  onCatClick: VoidFunction;
  onModalClose: VoidFunction;
  onClickPlaceAnAd: VoidFunction;
}

export const Cat: React.FC<ICatProps> = ({
  catVisible,
  modalVisible,
  device,
  onCatClick,
  onModalClose,
  onClickPlaceAnAd,
}) => {
  return (
    <div
      className={clsx(
        style['container'],
        catVisible && style['visible'],
        device === 'phone' && style['container-phone'],
      )}
    >
      <div className={style['ready']} />
      <div data-name="CatImage" className={style['cat']} onClick={onCatClick} />
      <ModalWindow
        open={modalVisible}
        onClose={onModalClose}
        content={
          <div className={style['modal-container']}>
            <div className={style['cat-meditation']} />
            <div className={style['title']}>
              <ArticleHeading4 fontWeight="400" textAlign="center">
                Используйте наши советы, чтобы&nbsp;сделка прошла спокойно!
              </ArticleHeading4>
            </div>
            <div className={style['btn']}>
              <LinkButton onClick={onClickPlaceAnAd} size="M" href={LINK_AN_AD} target="_blank">
                Разместить объявление
              </LinkButton>
            </div>
          </div>
        }
      />
    </div>
  );
};
